import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import * as moment from 'moment';
import { runInThisContext } from 'vm';

@Component({
  selector: 'app-score-certificate',
  templateUrl: './score-certificate.component.html',
  styleUrls: ['./score-certificate.component.css']
})
export class ScoreCertificateComponent implements OnInit {
  @ViewChild('scoreCertificatetemplate') public scoreCertificatetemplate :ElementRef;
  @Input('onloaddownload') public onloaddownload = true;
  @Input('downloadCertificateEmitter') public downloadCertificateEmitter:any;
 
 @Input('testUtility') public testUtility:any;
 public dateofexam
  constructor() { 

  }
  public user_details:any ={}

  ngOnInit(): void {
 
    this.user_details = !!localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')):(this.testUtility?.userDetails ?this.testUtility?.userDetails:{} )
    this.dateofexam = this.dateofexam?this.dateofexam :(moment(this.testUtility?.testResponse?.examSubmittedOn).format('DD/MM/YYYY'))
    if(this.downloadCertificateEmitter){
      this.downloadCertificateEmitter.subscribe(()=>{
        this.certificateDownload();
      })
    }
  

  }
certificateDownload(){
    html2pdf().from(this.scoreCertificatetemplate?.nativeElement?.innerHTML).set({
      filename: 'Score_certificate.pdf',
      image: { type: 'jpeg', quality: 1 },
      margin: 0,
      pagebreak: {mode: 'legacy' },
      jsPDF: {orientation: 'landscape', unit: 'in'}
    }).save();  
}
  ngAfterViewInit(){
    if(this.onloaddownload){
    this.certificateDownload() 
  }
  }
  
}
